import { Component, OnInit, OnDestroy, EventEmitter, Output } from '@angular/core';
import * as am5 from "@amcharts/amcharts5";
import * as am5xy from "@amcharts/amcharts5/xy";
import * as am5exporting from "@amcharts/amcharts5/plugins/exporting";
import am5themes_Animated from "@amcharts/amcharts5/themes/Animated";
import { DatabaseService } from '../../../../core/_services/database.service';
import { LotteryService } from '../../../../core/_services/lottery.service';
import { LotteryDrawn } from '../../../../core/_shared/models/lottery-draw.model';
import { LotteryDrawTask } from '../../../../core/_shared/models/task-queue.model';
import { LotteryTaskStatuses } from '../../../../core/_shared/models/task.model';
import { ActivatedRoute } from '@angular/router';
import { Observable } from 'rxjs';
import { map, startWith } from 'rxjs/operators';
import { UntypedFormControl } from '@angular/forms';
import { LottteryFrequency } from '../../../../core/_shared/utils/lottery-frequency';
import { WhereFilterOp } from '../../../../core/_services/database-cast/IDatabase';
import { Lottery } from '../../lottoloca-commom/lottery-modex';
import { ControllersService } from '../../../../core/_services/controllers/controllers.service';
import * as XLSX from 'xlsx';
import * as FileSaver from 'file-saver';

@Component({
  selector: 'kt-frequency-statistics',
  templateUrl: './frequecy-statistics.component.html',
  styleUrls: ['./frequecy-statistics.component.scss']
})
export class FrequencyStatisticsComponent implements OnInit, OnDestroy {

  subscribleChart: () => void;

  _chartRoot: am5.Root;
  _chart: am5xy.XYChart;

  _description: string;
  _progress: number = 0;
  _showGraph: boolean = true;
  _lottery: Lottery;
  _rangeOptions: { id: number; name: string; }[];
  _groupLens: any[] = [];

  _isControl: boolean = false;
  @Output() public click: EventEmitter<any> = new EventEmitter();

  _graphHeight: string = "0px";
  _lotteryDrawn: LotteryDrawn;

  _startLotteryDrawControl = new UntypedFormControl();
  _endLotteryDrawControl = new UntypedFormControl();
  _rangeOptionsControl = new UntypedFormControl();

  _options: string[] = ['One', 'Two', 'Three'];

  _startfilteredOptions: Observable<string[]>;
  _endfilteredOptions: Observable<string[]>;
  _endLotteryDrawLabel: string;
  _startLotteryDrawLabel: string;
  _updateChartLabel: string;
  _groupLen: any;
  _sort: string = "desc";

  constructor(
    private _database: DatabaseService,
    private _lotteryService: LotteryService,
    private activateRoute: ActivatedRoute,
    private _controllersService: ControllersService
  ) {
    this._rangeOptionsControl.setValue("1");

    this._startfilteredOptions = this._startLotteryDrawControl.valueChanges
      .pipe(startWith(''), map(value => this._filter(value)));

    this._endfilteredOptions = this._endLotteryDrawControl.valueChanges
      .pipe(startWith(''), map(value => this._filter(value)));

    this._rangeOptionsControl.valueChanges.subscribe(() => this.onRefreshClick());

    this._startLotteryDrawLabel = "Concurso inicial";
    this._endLotteryDrawLabel = "Concurso final";
    this._updateChartLabel = "Atualizar Gráfico";
  }

  ngOnInit() {
    this.activateRoute.params.subscribe(param => {
      this._groupLen = param.groupLen ?? 1;
      this._isControl = !param.groupLen;
      this.refreshAll();
    });

    this._lotteryService.getCurrentLotteryMode().then(lottery => {
      lottery.FrequencyStatistics.forEach(groupLen => {
        this._groupLens.push({ id: groupLen, name: LottteryFrequency.getLabelToStatisticsFrequency(groupLen) });
      });
    });
  }

  ngOnDestroy(): void {
    if (this.subscribleChart) this.subscribleChart();
    if (this._chartRoot) this._chartRoot.dispose();
  }

  private _filter(value: string): string[] {
    const filterValue = (value || '').toLowerCase();
    const filtered = this._options.filter(option => option.toLowerCase().includes(filterValue));
    return filtered.length > 100 ? filtered.slice(0, 100) : filtered;
  }

  changeGroupLen(groupLen) {
    if (groupLen) {
      this._groupLen = groupLen;
      this.refreshAll();
    }
  }

  refreshAll() {
    this._progress = 0;

    this._description = LottteryFrequency.getLabelToStatisticsFrequency(this._groupLen);
    this._lotteryService.getCurrentLotteryMode().then(lottery => {
      this._lottery = lottery;
      this._database.getLotteryDraws().getLotteryDraw(lottery.id).getData().then(lotteryDrawn => {
        if (lotteryDrawn) {
          this._lotteryDrawn = lotteryDrawn;
          this._options = this._lotteryDrawn.Ids.map(x => parseInt(x.toString()).toString());
          this._startLotteryDrawControl.setValue(parseInt(this._lotteryDrawn.Min));
          this._endLotteryDrawControl.setValue(parseInt(this._lotteryDrawn.Max));



          this.refreshChart();
        }
      });
    });
  }

  refreshChart(): void {
    this._graphHeight = "0px";
    this._progress = 0;

    this.clearChart();

    this._lotteryService.getCurrentLotteryMode().then(lottery => {
      const start = this._lotteryDrawn.Ids.find(x => parseInt(x) == parseInt(this._startLotteryDrawControl.value));
      const end = this._lotteryDrawn.Ids.find(x => parseInt(x) == parseInt(this._endLotteryDrawControl.value));

      this._rangeOptions = lottery.awardParams.map(x => ({ id: x.index, name: x.description }));
      let index = this._rangeOptionsControl.value || "1";

      if (!start || !end || start >= end) return;

      if (this.subscribleChart) this.subscribleChart();

      this.subscribleChart = this._database.getLotteryDraws()
        .getLotteryDraw(lottery.id)
        .getDocument().collection(`statistics/frequency/${this._groupLen}`)
        .doc(`${start}-${end}-${index}`)
        .onSnapshot(snapshot => {
          const data = snapshot.data();
          if (!data) {
            this.buildGraph(lottery, start, end, index);
          } else if (data.Pages && data.Pages > 0) {
            this._showGraph = true;
            let list = [];
            let operation: WhereFilterOp = data.Pages <= 3 ? ">=" : this._sort === "desc" ? ">=" : "<=";
            let operationValue = data.Pages <= 3 ? 1 : data.Pages - 1;

            this._database.getLotteryDraws()
              .getLotteryDraw(lottery.id)
              .getDocument().collection(`statistics/frequency/${this._groupLen}/${start}-${end}-${index}/pages`)
              .where("Page", operation, operationValue)
              .get()
              .then(queryResult => {
                queryResult.docs.forEach(doc => {
                  list = [...list, ...doc.data().Items];
                });
                this._graphHeight = `${list.length * 50}px`;
                this.drawChart(list);
              });
          } else {
            this._showGraph = false;
            this._graphHeight = "0px";
            this._progress = data.Progress * 100;
          }
        });
    });
  }

  lastBuildGraph = '';

  buildGraph(lottery, start, end, index) {
    const currentBuildGraph = `${lottery.id}-${this._groupLen}-${start}-${end}-${index}`;
    if (this.lastBuildGraph === currentBuildGraph) return;

    this.lastBuildGraph = currentBuildGraph;
    this._showGraph = false;

    const lotteryDrawTask = new LotteryDrawTask();
    lotteryDrawTask.lotteryId = lottery.id;
    lotteryDrawTask.reportType = "frequency";
    lotteryDrawTask.status = LotteryTaskStatuses.Waiting;
    lotteryDrawTask.data = { minId: start, maxId: end, groupLen: this._groupLen, index };

    this._controllersService.getTasks().addLotteryDrawnTask(lotteryDrawTask).catch(console.log);

    setTimeout(() => { this.lastBuildGraph = ''; }, 60000 * 2);
  }

  onRefreshClick(): void {
    this.refreshChart();
  }

  clearChart(): void {
    if (this._chartRoot) this._chartRoot.dispose();
    this._chartRoot = am5.Root.new("chart-frequency-div");
    this._chartRoot.setThemes([am5themes_Animated.new(this._chartRoot)]);
    this._chart = this._chartRoot.container.children.push(am5xy.XYChart.new(this._chartRoot, {}));
  }

  drawChart(numbers: any[]): void {

    this._chart.xAxes.clear();
    this._chart.yAxes.clear();
    this._chart.series.clear();

    this._showGraph = true;
    if (!this._chartRoot) this.clearChart();


    let data = [...numbers];
    data.sort((a, b) => this._sort === "asc" ? b.Count - a.Count : a.Count - b.Count);

    const yAxis = this._chart.yAxes.push(am5xy.CategoryAxis.new(this._chartRoot, {
      categoryField: "Key",
      renderer: am5xy.AxisRendererY.new(this._chartRoot, {})
    }));

    yAxis.data.setAll(data);

    const xAxis = this._chart.xAxes.push(am5xy.ValueAxis.new(this._chartRoot, {
      renderer: am5xy.AxisRendererX.new(this._chartRoot, {})
    }));

    // const xAxis = this._chart.xAxes.push(am5xy.ValueAxis.new(this._chartRoot, {
    //   renderer: am5xy.AxisRendererX.new(this._chartRoot, {}),
    //   extraMax: 0.08 // 5% de espaço extra à direita
    // }));

    //     const maxCount = Math.max(...data.map(x => x.Count));
    //     const minCount = Math.min(...data.map(x => x.Count));
    // const paddedMax = Math.ceil(maxCount * 0.9); // +10% e arredonda pra cima
    // const paddedMin = minCount-10 > 0 ? minCount-10 : 0; // garante que o mínimo não seja negativo
    // // const paddedMin = Math.floor(minCount * 0.9); // -10% e arredonda pra baixo
    // const xAxis = this._chart.xAxes.push(am5xy.ValueAxis.new(this._chartRoot, {
    //   renderer: am5xy.AxisRendererX.new(this._chartRoot, {}),
    //   min: paddedMin,
    //   max: paddedMax,
    //   strictMinMax: true // impede ajuste automático
    // }));

    const series = this._chart.series.push(am5xy.ColumnSeries.new(this._chartRoot, {
      name: "Frequência",
      xAxis,
      yAxis,
      valueXField: "Count",
      categoryYField: "Key"
    }));

    series.columns.template.setAll({
      fillOpacity: 1,
      strokeOpacity: 0,
      height: am5.percent(50)
    });

    series.set("tooltip", am5.Tooltip.new(this._chartRoot, {
      labelText: this._groupLen == '1' ? "O número {categoryY} foi sorteado {valueX} vez(es)" : "Os números {categoryY} foram sorteados juntos {valueX} vez(es)"
    }));

    series.data.setAll(data);



    series.columns.template.events.on("click", (ev) => {
      const obj = Object.assign({ Key: '' }, ev.target.dataItem.dataContext);
      const numbers = obj.Key.split('-').map(x => parseInt(x));
      this.click.emit(numbers);
    });

    // series.bullets.push(() => {
    //   return am5.Bullet.new(this._chartRoot, {
    //     locationX: 1,
    //     sprite: am5.Label.new(this._chartRoot, {
    //       text: "{valueX}",
    //       fill: am5.color("#444444"), // cinza escuro
    //       centerY: am5.p50,
    //       centerX: am5.p0, // alinha ao início
    //       dx: 5,           // desloca para fora da barra
    //       populateText: true
    //     })
    //   });
    // });

    const max = Math.max(...data.map(x => x.Count));
    const min = Math.min(...data.map(x => x.Count));

    const medium = (max + min) / 2;
    series.bullets.push((root, series, dataItem) => {
      const value = dataItem.get("valueX");

      let color = am5.color("#444444");
      let deslocamento = 5;
      if (value >= medium) {
        deslocamento = -50;
        color = am5.color("#ffffff"); // branco
      }
      return am5.Bullet.new(root, {
        locationX: 1,
        sprite: am5.Label.new(root, {
          text: "{valueX}",
          fill: color,
          centerY: am5.p50,
          centerX: am5.p0,
          dx: deslocamento,
          populateText: true
        })
      });
    });


    const exporting = am5exporting.Exporting.new(this._chartRoot, {
      menu: am5exporting.ExportingMenu.new(this._chartRoot, {}),
      dataSource: {
        data: data.map(d => ({ numero: d.Key, frequencia: d.Count })),
        fields: ["numero", "frequencia"]  // <-- Obrigatório para CSV aparecer
      },
      filePrefix: "frequencia_" + new Date().toISOString().substring(0, 10)
    });


  }



exportToExcel() {
  const series = this._chart.series.getIndex(0);
  const data = series.dataItems.map(item => {
    const ctx = item.dataContext as any;
    return {
      Número: ctx.Key,
      Frequência: ctx.Count
    };
  });

  const worksheet = XLSX.utils.json_to_sheet(data);
  const workbook = { Sheets: { 'Frequência': worksheet }, SheetNames: ['Frequência'] };
  const excelBuffer: any = XLSX.write(workbook, { bookType: 'xlsx', type: 'array' });

  const blob = new Blob([excelBuffer], { type: 'application/octet-stream' });
  FileSaver.saveAs(blob, 'Frequencia_'+ new Date().toISOString().substring(0, 10)+'.xlsx');
}


  changeSort(event) {
    this.refreshChart();
  }
}
